import { render, staticRenderFns } from "./EncounterCard.vue?vue&type=template&id=3875ebb8&scoped=true"
import script from "./EncounterCard.vue?vue&type=script&lang=js"
export * from "./EncounterCard.vue?vue&type=script&lang=js"
import style0 from "./EncounterCard.vue?vue&type=style&index=0&id=3875ebb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3875ebb8",
  null
  
)

export default component.exports